var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"email_block_paragraph",class:[_vm.advanced.cssClasses, _vm.responsiveClasses],style:(_vm.style),attrs:{"id":_vm.advanced.cssId},domProps:{"innerHTML":_vm._s(_vm.details.content || '<h3>Default headline item</h3>')}},[_vm._v("Lorem ipsum")])
}
var staticRenderFns = []

export { render, staticRenderFns }